"use client";

import { FC } from "react";
import { usePostHog } from "posthog-js/react";
import ListItem from "apps/website/components/base/ListItem/ListItem";
import Icon from "apps/website/components/base/Icon/Icon";
import Text from "apps/website/components/base/Text/Text";
import {
  Display,
  legacySizeCollectionMap,
} from "apps/website/components/base/Text/Text.map";
import cx from "apps/website/utils/misc/cx";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";

export interface IConditionalCheckLisItemCondition {
  key: string;
  value: string;
}

export interface IConditionalCheckLisItemProps {
  condition: IConditionalCheckLisItemCondition;
  text: string;
  display?: Display;
}

const ConditionalCheckListItem: FC<IConditionalCheckLisItemProps> = ({ text, display }) => {
  const posthog = usePostHog();
  const isPrimingScreenTest = posthog.getFeatureFlag("priming-screen-suf-3") === "test";

  return (
    <ListItem component={ConditionalCheckListItem.name} className={isPrimingScreenTest ? "mb-2" : "mb-4"}>
      <div className={cx("rounded-full bg-green mr-2 w-6 h-6", isPrimingScreenTest && "bg-green-dark ")}>
        <Icon icon="tickHeavy" size="xsmall" className={isPrimingScreenTest ? "text-light-grey" : ""}/>
      </div>
      { isPrimingScreenTest ? (
        <TextBody size={2}>
          { text }
        </TextBody>
      ) : (
        <Text tag="span" display={display || "default"} size={legacySizeCollectionMap.base}>
          { text }
        </Text>
      ) }
    </ListItem>
  );
};

export default ConditionalCheckListItem;
